import { aboutUs } from './aboutUs';
import { affiliate } from './affiliate';
import { legal } from './legal';

const externalLinks = { aboutUs, legal, affiliate };

export default externalLinks;
